module.exports = __webpack_public_path__ + "img/ncLoading.7b09bfd3.png";